import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import RequestStatus from '../../constants/edit/RequestStatus';
import StateConstants from '../../constants/StateConstants';
import { isPublished as getIsPublished } from '../../utils/articleUtils';
import { validateArticleState } from '../../utils/editUtils';
import ActionTemporarilyDisabledTooltip from '../ActionTemporarilyDisabledTooltip';
import DomainNotConnectedErrorTooltip from '../DomainNotConnectedErrorTooltip';
import PermissionsTooltip from '../PermissionsTooltip';
import ErrorsAndWarningsTooltip from './ErrorsAndWarningsTooltip';
import { getLanguageNameFromCode } from '../../utils/langUtils';
import { useFetchKnowledgeBase } from '../../knowledge-base/queries/KnowledgeBasesQuery';
import { jsx as _jsx } from "react/jsx-runtime";
const PublishButton = ({
  article,
  articleCategoryTranslationLanguages = [],
  articleSubcategoryTranslationLanguages = [],
  customSlugEnding,
  disablePublish,
  hasSelectedCategory,
  hasSelectedSubcategory,
  hasBufferedChanges,
  isDomainNotConnectedError,
  isPublishArticleTemporarilyDisabled,
  isMissingCategoryTranslation,
  isMissingSubcategoryTranslation,
  noSelectedListError,
  noSelectedAccessGroupError,
  knowledgeScopes,
  onPublishArticle,
  onErrorFocus,
  saveStatus,
  selectedCategoryId
}) => {
  const {
    data: knowledgeBase
  } = useFetchKnowledgeBase(article.values.hs_group_id);
  const articleNotInLanguageSupportedByKnowledgeBase = !!knowledgeBase && knowledgeBase.language !== article.values.hs_language && !knowledgeBase.additionalLanguages.includes(article.values.hs_language);
  const isMasterArticle = !article.values.hs_translated_from_id && article.translations && Object.keys(article.translations).length > 0;
  let missingVariantCategoryLanguages;
  let missingVariantSubcategoryLanguages;
  let isMissingVariantCategoryTranslation;
  let isMissingVariantSubcategoryTranslation;
  if (isMasterArticle) {
    const publishedArticleTranslationLanguages = article.translations && Object.values(article.translations).filter(translation => translation.values.hs_state === StateConstants.PUBLISHED).map(translation => translation.values.hs_language) || [];
    missingVariantCategoryLanguages = publishedArticleTranslationLanguages.filter(language => !articleCategoryTranslationLanguages.includes(language)).map(language => getLanguageNameFromCode(language));
    missingVariantSubcategoryLanguages = publishedArticleTranslationLanguages.filter(language => !articleSubcategoryTranslationLanguages.includes(language)).map(language => getLanguageNameFromCode(language));
    isMissingVariantCategoryTranslation = hasSelectedCategory && missingVariantCategoryLanguages.length > 0;
    isMissingVariantSubcategoryTranslation = hasSelectedSubcategory && missingVariantSubcategoryLanguages.length > 0;
  }
  const {
    errors,
    warnings
  } = validateArticleState(customSlugEnding, noSelectedListError, noSelectedAccessGroupError, selectedCategoryId, article, isMissingCategoryTranslation, isMissingSubcategoryTranslation, isMissingVariantCategoryTranslation, isMissingVariantSubcategoryTranslation, articleNotInLanguageSupportedByKnowledgeBase, Boolean(knowledgeBase && knowledgeBase.isKnowledgeBasePrivate));
  const isPublished = getIsPublished(article);
  const hasNoChangesToPublish = hasBufferedChanges === false && isPublished;
  const hasNoPublishOrWriteScope = !knowledgeScopes.canPublishArticle || !knowledgeScopes.canWriteArticle;
  const hasErrors = errors.length > 0;
  const hasWarnings = warnings.length > 0;
  const isButtonDisabled = disablePublish || isPublishArticleTemporarilyDisabled || hasErrors || hasNoPublishOrWriteScope || isDomainNotConnectedError || saveStatus === RequestStatus.FAILED || hasNoChangesToPublish;
  const buttonText = isPublished ? 'update' : 'publish';
  const publishButton = /*#__PURE__*/_jsx(Button, {
    "data-test-id": "publish-article",
    disabled: isButtonDisabled,
    onClick: onPublishArticle,
    use: "primary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `knowledgeContentUI.button.${buttonText}`
    })
  });
  if (hasNoPublishOrWriteScope) {
    return /*#__PURE__*/_jsx(PermissionsTooltip, {
      children: publishButton
    });
  }
  if (isDomainNotConnectedError) {
    return /*#__PURE__*/_jsx(DomainNotConnectedErrorTooltip, {
      children: publishButton
    });
  }
  if (hasErrors || hasWarnings) {
    return /*#__PURE__*/_jsx(ErrorsAndWarningsTooltip, {
      errors: errors,
      onErrorFocus: onErrorFocus,
      missingVariantCategoryLanguages: missingVariantCategoryLanguages,
      missingVariantSubcategoryLanguages: missingVariantSubcategoryLanguages,
      warnings: warnings,
      children: publishButton
    });
  }
  return /*#__PURE__*/_jsx(ActionTemporarilyDisabledTooltip, {
    disabled: !isPublishArticleTemporarilyDisabled,
    children: publishButton
  });
};
export default PublishButton;